import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getUserSellTractorSearchData,
  IGetUserSellTractorSearchParams,
  IUseGetUserSellTractorSearchDataReturn,
} from '../../../../api/userSellTractor/queries/getUserSellTractorSearchData';

export const useGetUserSellTractorSearchData = (
  searchParam: IGetUserSellTractorSearchParams,
  options?: UseQueryOptions<IUseGetUserSellTractorSearchDataReturn, AxiosError>,
) => {
  return useQuery<IUseGetUserSellTractorSearchDataReturn, AxiosError>(
    ['user-sell-tractor-search-data', searchParam.q, searchParam.limit, searchParam.offset],
    async () => {
      const data = await getUserSellTractorSearchData(searchParam);
      return data;
    },
    {
      ...options,
    },
  );
};
